<template>
  <button
    type="button"
    class="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border transition-colors"
    :class="active
      ? 'bg-primary-500 border-primary-500 text-white'
      : 'bg-white border-gray-200 text-gray-600 hover:border-primary-300 hover:text-primary-600 hover:bg-primary-50'"
    @click="$emit('click')"
  >
    <font-awesome-icon
      :icon="getEntityIcon({ entity_type_name: type.type_name })"
      class="w-3 h-3"
      :class="active ? 'text-white/80' : 'text-gray-400'"
      aria-hidden="true"
    />
    {{ formatEntityTypeName(type.type_name) }}
  </button>
</template>

<script>
import { formatEntityTypeName } from '@/utils/entityTypeFilters'
import { getEntityIcon } from '@/utils/entityIcons'

export default {
  name: 'EntityTypeFilterPill',
  props: {
    type: { type: Object, required: true },
    active: { type: Boolean, default: false },
  },
  emits: ['click'],
  methods: {
    formatEntityTypeName,
    getEntityIcon,
  },
}
</script>
